import React from "react";
import {
    FaEye,
    FaPowerOff,
    FaCircle,
    FaSyncAlt
} from "react-icons/fa";

import InstallationDetailsModal  from './InstallationDetailsModal';




class InstallationTable extends React.Component {


    getHeartbeatStatus(lastHeartbeat){

        if(!lastHeartbeat)
            return "OFFLINE";


        const diff =
            (Date.now() - new Date(lastHeartbeat)) / 1000;


        if(diff < 120)
            return "ONLINE";


        if(diff < 900)
            return "DELAYED";


        return "OFFLINE";

    }



    render(){

        const installations =
            this.props.installations || [];


        return (

            <div className="installation-container " >


                <div className="installation-header">

                    {/*<h3>
                        Active MT5 Installations
                    </h3>*/}

                    <div className="installation-header-actions">

                        <span className="installation-counter">

                            {installations.length} / 3 Slots Used

                        </span>

                        <button

                            className="refresh-installations"

                            title="Refresh installations"

           
                            onClick={() => {

                                console.log("Refresh clicked");

                                this.props.onRefresh();

                            }}

                        >

                            <FaSyncAlt />

                        </button>

                    </div>

                </div>



                {

                installations.length === 0 ?


                (

                    <div className="empty-installation">

                        No active installations

                    </div>

                )


                :

                installations.map(item => {


                    const heartbeatStatus =
                        this.getHeartbeatStatus(
                            item.lastHeartbeat
                        );


                    return (


                    <div

                    className="installation-card"

                    key={item.installationId}

                    >



                        <div className="installation-card-row">


                            {/*<div className="installation-column symbol">


                                <strong>
                                    {item.symbol}
                                </strong>


                                <span>

                                    {item.timeframe}

                                </span>


                            </div>*/}



                            <div className="installation-info">

                                   <div  className="installation-column">

                                        symbol:

                                        <strong>
                                            {item.symbol}
                                        </strong>

                                    </div>

                                     <div  className="installation-column">

                                        TF:

                                        <strong>
                                            {item.timeframe}
                                        </strong>

                                    </div>


                                    <div  className="installation-column">

                                        Chart:

                                        <strong>
                                            {item.chartId}
                                        </strong>

                                    </div>



                                    <div  className="installation-column">

                                        Broker:

                                        <strong>
                                            {item.broker}
                                        </strong>

                                    </div>



                                    <div className="installation-column">

                                        Account:

                                        <strong>
                                            {item.mt5Account}
                                        </strong>

                                    </div>


                            </div>



                            <div className="installation-column status">


                                <span>

                                    <FaCircle

                                    className={
                                    heartbeatStatus==="ONLINE"
                                    ?
                                    "online-dot"
                                    :
                                    heartbeatStatus==="DELAYED"
                                    ?
                                    "delayed-dot"
                                    :
                                    "offline-dot"
                                    }

                                    />

                                    {heartbeatStatus}


                                </span>


                                <small>

                                EA {item.eaVersion}

                                </small>


                            </div>


                        </div>



                        <div className="installation-actions">


                            <button

                            className="details-button"

                            onClick={() => {

                                      this.props.onDetails(item);
                                      //console.log("DETAILS CLICKED", item);
                                }
                            }

                            >

                                <FaEye/>

                                Details

                            </button>



                            {this.props.showDetailsModal && (

                                    <div className="installation-details-popup">

                                        <InstallationDetailsModal
                                            installation={this.props.selectedInstallation}
                                        />

                                    </div>

                            )}



                            <button

                            className="deactivate-button"

                            onClick={() =>
                                this.props.onDeactivate(item)
                            }

                            >

                                <FaPowerOff/>

                                Deactivate

                            </button>


                        </div>



                    </div>


                    );


                })


                }



            </div>


        );

    }


}


export default InstallationTable;